/*
    cf7 
*/

export default class Cf7custom {
    constructor(options = {}) {
        const defaultOptions = {
            reqInput: '.wpcf7 .i-w.req',
            sendBt: '.js-send-bt',
            agreeCheckbox: '.js-agree-checkbox'
        }

        this.options = {...defaultOptions, ...options};

        this.init();
    }

    init() { 
        //иденьтфикатор обязательных
        var reqFields = document.querySelectorAll(this.options.reqInput);
        if(reqFields) {
            for(let el of reqFields) {
                el.addEventListener('keyup', e => {
                    let v = el.querySelector('input');
                    if(v.value != ''){
                        el.classList.add('edit');
                    } else {
                        el.classList.remove('edit');
                    }
                    
                });
            }
        }
        //кнопка отправки
        var sendBt = document.querySelectorAll(this.options.sendBt);
        if(sendBt) {
            for(let el of sendBt) {
                el.addEventListener('click', e => {
                    let wrap = el.closest('.input-wrap');
                    let orig_send = wrap.querySelector('.wpcf7-submit');
                    let agree = wrap.querySelector(this.options.agreeCheckbox);
                    if( agree ){
                        if(agree.checked){
                            wrap.querySelector('.wpcf7-response-output').innerHTML = "";
                            wrap.querySelector('.wpcf7-form').classList.remove('invalid');
                            wrap.querySelector('.wpcf7-form').classList.add('init');
                            orig_send.click();
                        } else {
                            wrap.querySelector('.wpcf7-form').classList.add('invalid');
                            wrap.querySelector('.wpcf7-form').classList.remove('init');
                            wrap.querySelector('.wpcf7-response-output').innerHTML = "Необходимо согласиться с правилами использования и обработкой персональных данных";
                        }
                    }
                                  
                });
            }
        }
    }
}